import React from 'react'
import Image from 'next/image'
import { Grid, Spacer } from '@revelrygroup/components'

import staff from './staff'
import styles from './styles.module.scss'

export const Staff: React.FC = () => {
  return (
    <>
      {staff.map((staffSection) => (
        <Spacer key={staffSection.id} verticalBottom="lg">
          <Grid.Wrapper>
            {staffSection.staff.map((staff) => (
              <Grid.Item key={staff.name}>
                <Grid.ImageWrapper>
                  <Image
                    alt={staff.name}
                    className={styles.image}
                    layout="fill"
                    src={staff.image || '/default-obit.jpg'}
                    unoptimized
                  />
                </Grid.ImageWrapper>

                <Grid.Title>
                  <Spacer verticalLgTop="xs">{staff.name}</Spacer>
                </Grid.Title>

                <Grid.SubTitle>{staff.title}</Grid.SubTitle>
              </Grid.Item>
            ))}
          </Grid.Wrapper>
        </Spacer>
      ))}
    </>
  )
}
